import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import {
  ConsoleBillingPage,
  ConsoleManagerGuard,
  consoleBillingSummaryQueryOptions,
  consoleContextQueryOptions,
  consoleCreditsQueryOptions,
  consoleInvoicesQueryOptions,
} from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/billing")({
  // Intent preload — summary/credits/invoices (fire-and-forget). The gate
  // context IS awaited (returned) so the ConsoleManagerGuard's capability tier
  // is warm before render — no flash of the Fatturazione page for a Sviluppatore.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleBillingSummaryQueryOptions());
    void queryClient.ensureQueryData(consoleCreditsQueryOptions());
    void queryClient.ensureQueryData(consoleInvoicesQueryOptions());
    return queryClient.ensureQueryData(consoleContextQueryOptions());
  },
  component: ConsoleBillingRoute,
});

function ConsoleBillingRoute(): React.ReactElement {
  return (
    <ConsoleManagerGuard>
      <ConsoleBillingPage />
    </ConsoleManagerGuard>
  );
}
